// To do local development (npm start), copy this file to firebase.local.js 
// and update with your config. This will overwrite staging and production
// setting.
module.exports = {
  apiKey: "AIzaSyAmcV_Ogtl3aPuRBrvfY1TPRjx6Ukzd_Wk",
  authDomain: "woundostomyprep.firebaseapp.com",
  projectId: "woundostomyprep",
  storageBucket: "woundostomyprep.firebasestorage.app",
  messagingSenderId: "537399426464",
  appId: "1:537399426464:web:0acf3b92e945025c23f8c5",
  measurementId: "G-4XPCDVN622"
};